/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";



export const AuditActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openAuditOptionDialog }
) => (
  <>

    <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">تکمیل پرسشنامه</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openAuditOptionDialog(row.id)}
      // onClick={() => openEditObjectPage(row.formTypeId,row.auditListId)}
      // onClick={() => openEditObjectPage(row.formTypeId)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>

    {/* <> </>
    <OverlayTrigger
      overlay={<Tooltip id="objects-delete-tooltip">حذف</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-danger btn-sm"
        onClick={() => openDeleteObjectDialog(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-danger">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
        </span>
      </a>
    </OverlayTrigger> */}
  </>
);


export const AuditListAnswerColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openAnswerDialog }
) => (
  <>
    {row.status !== "Completed" &&
      <OverlayTrigger
        overlay={<Tooltip id="objects-edit-tooltip">تکمیل پرسشنامه</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => openAnswerDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    }

    {row.status === "Completed" &&
      <OverlayTrigger
        overlay={<Tooltip id="objects-edit-tooltip">تکمیل پرسشنامه</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary text-gray disabled btn-sm mx-3"
        // onClick={() => openAnswerDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    }
  </>
);